import { MDB_TYPES, ANALYSIS_TYPES, intvVariant2JSON, } from '@meddbriefer/scenario-data';
import {
    initializeConstraints,
    //getConstraint,
    filterConstraintsBySolutions,
    getStatesForStatus,
    getEventsByIdTime,
    pushNew,
    trimActions,
    getItem,
    scenarios,  //just for debugging
} from "./debriefingUtils";

import { summarizeAnalysis } from "./summarizeAnalysis"; //for debug

import { checkAgainstKB } from './constraintHandling';

import {
    insertInPhaseRelativeToSuggestedOrder,
    //hasSubPhases,
} from "./actionInsertion";

import { checkForMinimalCases } from './handleMinimal';

import { organizeLogDisplay } from './organizeCond1Display';

//import { doVitalsCounts, doVitalsFeedback } from './vitalsChecking';

import {
    intvChecks,
    exceptionDefs,
    fbTemplatesDef,
} from "@meddbriefer/feedback-data"

import { processInterventionAnswers, processAssessmentAnswers, getPrescribedInvAnswers, initializePromptAnswerGrading, getPromptLabel, getAnswerLabel } from "@meddebriefer/prompt-answer-grading";


import { getChecklistItemsByType, getChecklistHierarchy, groupByKey } from './scenarioDataAccesors';
import { inferenceCheckingForAssessments } from './inferencing';


let debugSummarize = false

let problemStates
let cautionStates
let constraintsViolated = []
let insertInterventionHeader = false  //setting to true helps during debugging analysis, shows headers for problems
//index of subphase names and value is phase id to which belongs
let subPhases = {}
// list of all subphase IDs
let requiredSubphases
let requiredPhaseNames = []
let requiredPhaseAndSubPhases
let phaseRequiredAtEnd
let scenario
//let version
let phaseFB
var promptIDs = {}
var itemByID
var itemByLabel
// sts 1/23/22 - added as global
let checklistHierarchy
let training

// analysisFields to include in output
let analysisFields = [
    "numericalID",
    "actionDescription",
    "id",
    "type",
    "label",
    "labelID",
    "answerDetails",
    "variantDetails",
    "intvVariant",
    "vital",
    "vitalType",
    "value",
    "subPhase",
    "finding",
    "intvStatus",
    "vitalsStage",
    "vitalsStageCoverage",
    "probLabel",
    "feedback",
    "phFeedback",
    "phaseOrderStatus",
    "lateRelativeTo",
    "why",
    "orderingFB",
    "vitalsFB",
    "minVitalsFB",
    "incorrectAnswersFB",
    "intvStatusFB",
    "redundantToFB",
    "minimalWhy",
    "timestamp",
    "status",
    "displayColor",
    "comment",
]

function initGlobals(scen) {
    problemStates = getStatesForStatus("Problem", fbTemplatesDef)
    cautionStates = getStatesForStatus("Caution", fbTemplatesDef)
    phaseRequiredAtEnd = "ongoing-mgmt-plan"
    scenario = scen
    initializeConstraints(scen.name)
    getPromptIDs(scenario)
    training = scenario.info.debriefing
    initializePromptAnswerGrading(scenario)
    itemByID = initializeItemLookupByID(scen)
    itemByLabel = initializeItemLookupByLabel(scen)
    requiredPhaseNames = getChecklistItemsByType(scen, MDB_TYPES.PHASE).map(e => e.id).concat(["Unknown"])
    requiredSubphases = getChecklistItemsByType(scen, MDB_TYPES.SUB_PHASE).map(e => e.id)
    checklistHierarchy = getChecklistHierarchy(scen)
    requiredPhaseAndSubPhases = findPhaseSubphasesOrdered(checklistHierarchy)
    checklistHierarchy.forEach(ph => {
        if (undefined === ph.subPhases) {
            subPhases[ph.id] = ph.label
        }
        else {
            ph.subPhases.forEach(sp => {
                subPhases[sp.id] = ph.label
            })
        }
    })
    subPhases["Unknown"] = "Unknown"
    // initializeC2FB(scen)
    constraintsViolated = []
    phaseFB = []
}



function getPromptIDs(scen) {
    if (scen._interventionPrompts) {
        let prompts = scen._interventionPrompts
        prompts.forEach(prompt => {
            promptIDs[prompt.id] = prompt.label
        })

    }
}


//This starts section for accessing checklist and intervention components by id or label
const initializeItemLookupByID = (scenario) => {
    let checklistLookupByID = groupByKey(scenario._checkListMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "id")
    let intvLookupByID
    if (!!scenario._interventions) {
        intvLookupByID = groupByKey(scenario._interventions, "id")
    }
    else { intvLookupByID = groupByKey(scenario.intvMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "id") }
    let result = Object.assign(checklistLookupByID, intvLookupByID)
    return result
}

const initializeItemLookupByLabel = (scenario) => {
    let checklistLookupByLabel = groupByKey(scenario._checkListMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "label")
    let intvLookupByLabel
    if (!!scenario._interventions) {
        intvLookupByLabel = groupByKey(scenario._interventions, "label")
    }
    else { intvLookupByLabel = groupByKey(scenario.intvMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "label") }
    let result = Object.assign(checklistLookupByLabel, intvLookupByLabel)
    return result
}


const findPhaseSubphasesOrdered = (phases) => {
    let result = []
    phases.forEach(ph => {
        if (!!ph.subPhases) {
            let subPhIds = ph.subPhases.map(e => e.id)
            //not currently useful to collect parent phases unless there were no subphases
            //if parent phase included subphases and steps then it should be in this result
            //result = result.concat(ph.id)
            result = result.concat(subPhIds)
        }
        else { result = result.concat(ph.id) }
    })
    return result
}

const collectScenAssessments = (problems) => {
    let assessments = []
    problems.forEach(prob => {
        if (prob.assessments !== "") {
            assessments = assessments.concat(prob.assessments)
        }
    })
    return assessments
}

const collectScenInterventions = (problems) => {
    let interventions = []
    problems.forEach(prob => {
        if (prob.allActions !== "") {
            let ids = (prob.allActions).map(a => a.id)
            interventions = interventions.concat(ids)
            ids = (prob.allAlts).map(a => a.id)
            interventions = interventions.concat(ids)
        }
    })
    return interventions
}

//will need to update to comply with any relevant constraints on phases and subphases
//currently looks for missing phases/subphases and inserts them into the analysis list
//based on where last preceding phase appeared
const insertMissingSubphases = (phases, phaseNames) => {
    let priorPh
    requiredPhaseAndSubPhases.forEach((phase, i) => {
        if (!phaseNames.includes(phase)) {
            if (phase === phaseRequiredAtEnd) {  //needs special handling to be placed last
                priorPh = requiredPhaseAndSubPhases[requiredPhaseAndSubPhases.length - 2]
            }
            else {
                //find last index for phase before and splice that
                if (i === 0) {
                    priorPh = requiredPhaseAndSubPhases[0]
                }
                else { priorPh = requiredPhaseAndSubPhases[i - 1] }
            }

            let insertionIndex = 0
            if (priorPh !== phase) {
                insertionIndex = phaseNames.lastIndexOf(priorPh)  //if prior phase was missing it will have been inserted earlier
                insertionIndex = insertionIndex + 1
            }

            phaseNames.splice(insertionIndex, 0, phase); //insert it where it should have appeared
            phases.splice(insertionIndex, 0, []); //add the empty array for phase objects
        }
    });
    return [phases, phaseNames]
}


//as vital requests and intervention requests are made, update that it was requested
//if it is one that we are tracking for post intervention success.
const updateVital = (vitalEntries, timestamp) => {
    let updatedEntries = []
    vitalEntries.forEach(vitalEntry => {
        if (vitalEntry.timestamp < timestamp) {
            vitalEntry["foundCk"] = true
        }
        updatedEntries.push(vitalEntry)
    })
    return updatedEntries
}


const processRawLogForDisplay = (events) => {
    let processedForDisplay = []
    events.forEach((event, i) => {
        // Each eventObj is one of the lines in the displayed base log
        // Set up fields for extra annotations for this event after analyzing each event
        let eventObj = {
            "comment": "",
            "numericalID": i+1,
            "status": "test",
            "intvStatus": [], //will be an array what patient status checks were and weren't done
            "contraindicatedWhy": "",
            "minimalWhy": "",
            "why": "",
            "answerCorrect": "false",
            "answerDetails": {},
            "variantDetails": {},
            "expertPhase": "",  //filled in only for interventions
            "workingPhase": "",  //is subphase or if no suphase then the phase
            "suggestedPhase": "", //mostly for interventions so don't override info on when was originally done
            "phaseLabel": "", //label to display for the phase or subphase
            "protocol": "",
            "protocolRelationship": "",
            "probLabel": "",
            "solutionIds": [],
            "assessments": "",
            "required": false,
            "actionDescription": "",
            "assessmentFB": "",
            "incorrectAnswersFB": "",
            "orderingFB": "",
            "processingState": "good" // values of good/bad used to filter out events not needed for analysis or displaying
        };

        if (!event.answers) { eventObj.answerCorrect = true }

        // copy over the event fields that exist in the input log from observer UI (which is type dependent)
        const EVENT_FIELDS = ["id", "interventionID", "intvVariant",
            "label", "finding", "phase", "subPhase", "vitalType", "vital", "value", "type", "prompt", "promptID", "intervention", "timestamp", "probLabel"];
        EVENT_FIELDS.forEach(fldName => {
            if (!!event[fldName]) {
                eventObj[fldName] = event[fldName];
            }
        });


        if (event.type === "intervention") {
            if (!!event.interventionID) { eventObj.id = event.interventionID }
        }

        let item = getItem(eventObj.id, itemByID, itemByLabel)
        if (!!item) {
            eventObj.label = item.label
            eventObj.abbrLabel = item.abbrLabel
        }

        //copy event fields if defined to initialize some of the above annotation fields

        /* if (!!eventObj.abbrLabel){eventObj.actionDescription = eventObj.abbrLabel;}
        else {eventObj.actionDescription = eventObj.label;} */

        eventObj.actionDescription = eventObj.label;

        //if (!!event.type) { eventObj.status = event.type; }

        // prefer subPhase if available
        if (!!event.subPhase) {
            eventObj.workingPhase = event.subPhase;
            eventObj.phaseLabel = getItem(event.subPhase, itemByID, itemByLabel).label
        }
        else {
            if (!!event.phase) {
                eventObj.workingPhase = event.phase;
                eventObj.phaseLabel = getItem(event.phase, itemByID, itemByLabel).label
            }
        }
        eventObj.expertPhase = eventObj.workingPhase;
        processedForDisplay.push(eventObj)
    })
    let trimmedActions = trimActions(processedForDisplay, analysisFields)

    const retVal = {
        "events": trimmedActions,
        // "FBfields": c2FB,
        "constraintsViolated": [],
        "requiredPhaseNames": requiredPhaseNames,
        "promptIDs": promptIDs
        // "feedbackTemplates": assessmentEntries,
    }
    return retVal

}


/* function isEmpty(obj) {
        return Object.keys(obj).length === 0;
} */

const annotateInputEvents = (events, problems) => {
    let confirmedEvents = [];
    let interventionsConfirmed = [];  //needed for vital checking
    //instead of a multi-dimensional array, am using an array of phase and subphase names e.g. "BSI", "prinary" ...
    let phaseNames = [];
    let phases = []; //and another array with the actual content for each phase.  I can search phaseNames for the index into phases
    let phaseObjects = [];
    let trackForStatus = {};  //save correct interventions that were done that require status checks later
    //let altFound = undefined   //can have only one set of alternative interventions per problem


    // will create a phases entry of that name in phaseNames and then use that index to retrieve the appropriate phase entry
    //in structure phases to add on the missing items (assessment or intervention) for that phase
    let priorPhase = "";
    let parentPhase = ""
    let parentIndex = 0
    let phaseIndex = 0;
    let newPhaseStart = true
    let assessmentTypes = ["assessment", "required-action", "decision-option", "assessment-option"]

    // created annotated object for each event
    events.forEach((event, i) => {
        // Each eventObj is one of the lines in the displayed base log
        // Set up fields for extra annotations for this event after analyzing each event
        let eventObj = {
            "comment": "",
            "numericalID": i,
            "status": "",
            "intvStatus": [], //will be an array what patient status checks were and weren't done
            "contraindicatedWhy": "",
            "minimalWhy": "",
            "why": "",
            "answerCorrect": "false",
            "answerDetails": {},
            "variantDetails": {},
            "expertPhase": "",  //filled in only for interventions
            "workingPhase": "",  //is subphase or if no suphase then the phase
            "suggestedPhase": "", //mostly for interventions so don't override info on when was originally done
            "phaseLabel": "", //label to display for the phase or subphase
            "protocol": "",
            "protocolRelationship": "",
            "probLabel": "",
            "solutionIds": [],
            "assessments": "",
            "required": false,
            "actionDescription": "",
            "assessmentFB": "",
            "incorrectAnswersFB": "",
            "orderingFB": "",
            "processingState": "good" // values of good/bad used to filter out events not needed for analysis or displaying
        };

        if (!event.answers) { eventObj.answerCorrect = true }

        // copy over the event fields that exist in the input log from observer UI (which is type dependent)
        const EVENT_FIELDS = ["id", "interventionID", "intvVariant",
            "label", "finding", "phase", "subPhase", "vitalType", "vital", "value", "type", "prompt", "promptID", "intervention", "timestamp", "probLabel"];
        EVENT_FIELDS.forEach(fldName => {
            if (!!event[fldName]) {
                eventObj[fldName] = event[fldName];
            }
        });


        if (event.type === "intervention") {
            if (!!event.interventionID) { eventObj.id = event.interventionID }
        }

        let item = getItem(eventObj.id, itemByID, itemByLabel)
        if (!!item) {
            eventObj.label = item.label
            eventObj.abbrLabel = item.abbrLabel
        }

        //copy event fields if defined to initialize some of the above annotation fields

        /* if (!!eventObj.abbrLabel){eventObj.actionDescription = eventObj.abbrLabel;}
        else {eventObj.actionDescription = eventObj.label;} */

        eventObj.actionDescription = eventObj.label;

        if (!!event.type) { eventObj.status = event.type; }

        // prefer subPhase if available
        if (!!event.subPhase) {
            eventObj.workingPhase = event.subPhase;
            item = getItem(event.subPhase, itemByID, itemByLabel)
            if (!!item){
                eventObj.phaseLabel = item.label
        }}
        else {
            if (!!event.phase) {
                eventObj.workingPhase = event.phase;
                item = getItem(event.phase, itemByID, itemByLabel)
                if (!!item){
                    eventObj.phaseLabel = item.label}
            }
        }
        eventObj.expertPhase = eventObj.workingPhase;

        //if current phase same as prior then keep on with the current phase
        // otherwise initialize for a new phase but don' let an intervention
        // or intervention answer set a new phase since this info in event is
        // not reliable

        if (priorPhase !== eventObj.workingPhase || parentPhase !== eventObj.phase) {
            if (priorPhase !== "" && assessmentTypes.includes(eventObj.type)) {
                //have a non initial phase change and we have an assessment type (i.e. we can't base phase changes on interventions)
                newPhaseStart = true
                phases[phaseIndex] = phaseObjects;
                if (phaseIndex !== parentIndex) {
                    phases[parentIndex] = phases[parentIndex].concat(phaseObjects);
                }
                phaseIndex++

                //if upcoming parent phase is different than current parent phase then set up
                //for a new parent phase
                if (eventObj.phase !== parentPhase) {
                    parentPhase = eventObj.phase
                    parentIndex = phaseIndex
                    // if the upcoming is truly a parent with subphases
                    // then add an extra entry for the new parent phase
                    if (eventObj.phase !== eventObj.workingPhase) {
                        //create the new parent phase
                        phases[parentIndex] = []
                        phaseNames[parentIndex] = parentPhase
                        phaseIndex++
                    }
                }
            }
            else {
                if (priorPhase === "" && assessmentTypes.includes(eventObj.type)) {
                    // first item in events so initialize
                    parentPhase = eventObj.phase
                    // if the event parent phase is not the same as the subPhase
                    // then we need to save that parent phase in phases and phaseNames
                    if (parentPhase !== eventObj.workingPhase) {
                        parentPhase = eventObj.phase
                        phaseNames[parentIndex] = parentPhase
                        phases[parentIndex] = []
                        phaseIndex++;
                    }
                }

                else {
                    if (priorPhase === "") {
                        //did an intervention before doing any assessments
                        //so make up an initial phase of unknown
                        parentPhase = "Unknown"
                        eventObj.workingPhase = parentPhase
                        eventObj.phase = parentPhase
                        eventObj.subPhase = ""
                    }
                    else { newPhaseStart = false }
                }
            }



            //now setup for collecting for the current phase if not skipping new phase start
            if (newPhaseStart) {
                priorPhase = eventObj.workingPhase;
                phaseObjects = [];
                phaseNames[phaseIndex] = priorPhase;
                phases[phaseIndex] = []
            }
            else { newPhaseStart = true }
        }


        let eventType = eventObj.type;
        // List of types in log that are currently processed.  Rest are filtered out.
        let processedTypes = ["assessment", "required-action", "intervention", "obtain-vital-sign", "decision-option", "assessment-option"];

        //skip over adding anything not of these types to the debriefing display for now
        if (!processedTypes.includes(eventType)) {
            eventObj.processingState = "bad";
        }





        if (eventObj.processingState === "good") {

            if (eventObj.type === "obtain-vital-sign") {
                //if it is an intervention status check then the vital field contains
                //the intervention id and otherwise the vital label
                let vital = eventObj.vital
                let type = ""
                if (eventObj.vitalType === "intervention-status") {
                    if (interventionsConfirmed.includes(vital)) {
                        type = "intv"
                    }
                    else { type = "noIntv" }
                }
                else { type = "vital" }

                //update trackForStatus relative to this "vital"
                let vitalEntry = trackForStatus[vital]
                //set the status for this particular vital (i.e. makes sense to ask for it or not)
                switch (type) {
                    case "intv":
                        eventObj.status = "patientIntvCheck"
                        if (vitalEntry && (vitalEntry.timestamp < eventObj.timestamp)) {
                            vitalEntry["foundCk"] = true
                            trackForStatus[vital] = vitalEntry
                        }
                        break
                    case "noIntv":
                        eventObj.status = "intvCheckWNoIntvFound"
                        break
                    case "vital":
                        eventObj.status = "patientVitalCheck"
                        if (vitalEntry) {
                            vitalEntry = updateVital(vitalEntry, eventObj.timestamp)
                            trackForStatus[vital] = vitalEntry
                        }
                        break
                    default: eventObj.status = "unexpectedPatientIntvCheck"
                }



            }
            if (eventObj.type === "intervention") {
                let item = getItem(eventObj.id, itemByID, itemByLabel)  //sometimes item ids get edited during development
                if (!!item) {
                    eventObj.label = item.label
                    eventObj.actionDescription = eventObj.label
                    confirmedEvents.push(eventObj.id)
                    interventionsConfirmed.push(eventObj.id)
                }
                else {
                    eventObj.label = eventObj.id
                    eventObj.actionDescription = "No longer defined " + eventObj.label
                    confirmedEvents.push(eventObj.id)
                    interventionsConfirmed.push(eventObj.id)
                }

                // iterate through all problem actions looking how to format the
                // data structue for the current "event"
                problems.forEach((prob, j) => {
                    // We're going through intervention actions in the order required/needed and then other since
                    // it is possible but unlikely to have multiples and we want the last one to win.
                    // Also, we are assuming minimal is always a subset of goodIntv
                    const PROBLEM_ACTION_FIELDS = ["why", "probLabel", "protocolRelationship", "probLabel"];

                    // check for this action to be an intervention for a problem
                    prob.allActions?.forEach((action, k) => {
                        if (action.id === eventObj.id) {
                            //set up status tracking for the eventObj
                            trackForStatus = setupStatusChecking(eventObj, trackForStatus)

                            // fill out problem related fields in the action event
                            fillOutProblemFields(prob, PROBLEM_ACTION_FIELDS, eventObj, action)
                        }
                    });


                    prob.allAlts?.forEach((alt, j) => {
                        if (alt.id === eventObj.id) {
                            if (!prob.altFound) {
                                //set up status tracking for the eventObj
                                trackForStatus = setupStatusChecking(eventObj, trackForStatus)
                                fillOutProblemFields(prob, PROBLEM_ACTION_FIELDS, eventObj, alt)
                                prob.altFound = eventObj.label
                            }
                            else {
                                eventObj.status = "redundant"
                                eventObj.redundantToFB = prob.altFound
                            }
                        }

                    })


                    // check for this action to be a contraindication for a problem solution
                    prob.allContras?.forEach((contra, j) => {
                        if (contra.id === eventObj.id) {
                            event.intvVariant = "{}"  //if contra then we don't care about distinguisher prompt answers
                            eventObj.intvVariant = "{}"
                            eventObj.status = contra.protocolRelationship;
                            PROBLEM_ACTION_FIELDS.forEach(fldName => {
                                if (!!contra[fldName]) {
                                    eventObj[fldName] = contra[fldName];
                                }
                            });
                            if (!!prob.probLabel) { eventObj.probLabel = prob.probLabel; }
                        }
                    })
                })
                //Do the grading of the event and return an event with
                //added fields with results
                let variant = "{}"

                if (!!event.intvVariant && event.intvVariant !== "{}") {
                    let origVariant = JSON.parse(event.intvVariant) //convert string to object
                    let key = Object.keys(origVariant)[0]
                    let val = origVariant[key]
                    eventObj.variantDetails[key] = {label: getPromptLabel(key) , givenVariant: getAnswerLabel(val)}
                    //variant = "{\"" + key + "\":\"" + val + "\"}"  //not yet using the variant info during analysis

                }
                eventObj.variant = variant
                let prescribedAnswers = getPrescribedInvAnswers(event.interventionID, variant, scenario)
                eventObj = processInterventionAnswers(event, eventObj, prescribedAnswers, "incorrect-answers")

                //anything with leftover status of intervention means it wasn't part of the solution
                if (eventObj.status === "intervention") {
                    eventObj.status = "not indicated" }

            }

            if (eventObj.type === "decision-option") {
                let prescribedAnswers = scenario.checkListCorrectness
                let parentItem = getItem(event.parentID, itemByID, itemByLabel)
                if (parentItem) {
                    event.parentLabel = parentItem.label
                }
                eventObj = processAssessmentAnswers(event, eventObj, prescribedAnswers, "decision-option-incorrect")
            }

            if (eventObj.type === "assessment-option") {
                let prescribedAnswers = scenario.checkListCorrectness
                let parentItem = getItem(event.parentID, itemByID, itemByLabel)
                if (parentItem) {
                    event.parentLabel = parentItem.label
                }
                eventObj = processAssessmentAnswers(event, eventObj, prescribedAnswers, "assessment-option-incorrect")
            }

            // add the formatted object to our list of formatted objects for the current phase and the id to our set of confirmed ids
            if (eventObj.type === "intervention") {
                confirmedEvents.push(eventObj.id + "+" + eventObj.variant)
                interventionsConfirmed.push(eventObj.id)
            }
            else { confirmedEvents.push(eventObj.id) }
            phaseObjects.push(eventObj)
        }
    });

    // store the last phase processed
    phases[phaseIndex] = phaseObjects;
    if (phaseIndex !== parentIndex) {
        phases[parentIndex] = (phases[parentIndex]).concat(phaseObjects)
    };
    return [phases, phaseNames, confirmedEvents, trackForStatus]
}

//start support functions for intervention handling


const setupStatusChecking = (eventObj, trackForStatus) => {
    //see if this is an event whose status should be checked by the student
    //and initialize its tracking.  Not yet limiting to event id when
    //defining what needs to be tracked in the structure intvChecks
    //so also checking event label
    let statusChecking  //the entry retrieve from intvChecks
    let intv = eventObj.id
    statusChecking = intvChecks[eventObj.label]
    if (!statusChecking) {
        statusChecking = intvChecks[eventObj.id]
    }

    if (!!statusChecking) {
        let initialEntry = { "intervention": intv, "timestamp": eventObj.timestamp, "foundCk": false }
        //put the intervention on the list if there is a direct status check possible for it
        if (statusChecking.intvStatusNeeded) {
            trackForStatus[intv] = Object.assign({}, initialEntry)
        }
        //if any vitals are listed for this intervention as a way of checking its status then
        //put those on the statusChecking list.  Anytime a vital is checked after the timestamp
        //it will count towards checking the status of the intervention
        statusChecking.vitalsNeeded.forEach(vital => {
            if (!trackForStatus[vital]) { trackForStatus[vital] = [Object.assign({}, initialEntry)] }
            else { trackForStatus[vital].push(Object.assign({}, initialEntry)) }
        })
    }
    return trackForStatus

}

const fillOutProblemFields = (prob, PROBLEM_ACTION_FIELDS, eventObj, action) => {
    if (!!action.assessments) { eventObj.assessmentsNeeded = action.assessments }
    if (!!action.phase) {
        eventObj.when = action.phase
        eventObj.suggestedPhase = action.phase
    };
    if (!!prob.protocols) { eventObj.protocol = prob.protocols }
    if (eventObj.answerCorrect) {
        eventObj.status = "goodIntv";
    }
    else { eventObj.status = "incorrect-answers"; }
    //eventObj.probLabel = prob.probLabel;
    PROBLEM_ACTION_FIELDS.forEach(fldName => {
        if (!!action[fldName]) {
            eventObj[fldName] = action[fldName];
        }
    });
    if (!!action["id-label"]) { eventObj["label"] = action["id-label"]; }  //dealing with name changes in incoming data so software stays the same

}

//end supoort functions for intervention handling




//main function for dealing with missing assessment steps

const checkForMissingAssessments = (problems, events, confirmedEvents, phaseNames, phases) => {
    let neededScenAssessments = collectScenAssessments(problems)
    let indexCounter = events.length;
    var checklistSteps = scenario._checkListMetaData.filter(md => [MDB_TYPES.ASSESS, MDB_TYPES.REQUIRED].includes(md.type));

    // before evaluating assessment steps, deal with exceptional cases where one or more steps is not
    // necessary for a given scenario.  Because GCS value is a string and not a formatted object
    // we can't reliably parse out values and units to do more general checks so can only set what
    // steps should not be assessed for a particular scenario.  Requires info on feedback to give as
    // well.
    // Get any exceptional steps associated with the current scenario
    var exceptions = [];
    for (let exceptionDef of exceptionDefs) {
        if (exceptionDef.scenarioName === scenario.name) {
            exceptions = exceptionDef.exceptions;
            break;
        }
    }

    exceptions.forEach((exception, j) => {
        // remove the step from the checklist as it is not required
        checklistSteps = checklistSteps.filter(entry => entry.id !== exception[0]);

        // if the step was done during the observation then mark it as an issue
        if (confirmedEvents.includes(exception[0])) {
            // it could appear in any phase so check all phases and mark
            // each instancs as unnecessary
            phases.forEach((phaseObjects, j) => {
                phaseObjects.forEach((action, i) => {
                    if (action.id === exception[0]) {
                        action.why = exception[1];
                        action.status = "notNecessary";
                    }
                });
            });
        }

    });

    // iterate through all checklist steps for ones for which we don't have formated objects
    checklistSteps.forEach((cls, i) => {
        if (!confirmedEvents.includes(cls.id)) {
            // add so we don't check for the missing checklist item again
            confirmedEvents.push(cls.id);
            let phaseObject = {
                "comment": "",
                "numericalID": indexCounter,
                "status": "missingRequiredAssessment",
                "intvStatus": [], //will be an array what patient status checks were and weren't done
                "expertPhase": "",
                "workingPhase": "",
                "contraindicatedWhy": "",
                "minimalWhy": "",
                "why": "",
                "probLabel": "",
                "protocol": "",
                "actionDescription": "",
                "assessmentFB": "",
                "timestamp": -1
            };

            //copy over the step fields that exist (type dependent)
            //does prompt does exist in checlistSteps???  9/20/22
            const STEP_FIELDS = ["id", "label", "phase", "subPhase", "type", "prompt"];
            STEP_FIELDS.forEach(fldName => {
                if (!!cls[fldName]) {
                    phaseObject[fldName] = cls[fldName];
                }
            });
            let assessments = scenario.assessmentFindings
            phaseObject["finding"] = assessments[cls.id]
            let item
            if (!!cls.subPhase) {
                phaseObject.workingPhase = cls.subPhase;
                item = getItem(cls.subPhase, itemByID, itemByLabel)
                if (!!item) {
                    phaseObject.phaseLabel = item.label
                }
            }
            else {
                if (!!cls.phase) {
                    phaseObject.workingPhase = cls.phase;
                    item = getItem(cls.phase, itemByID, itemByLabel)
                    if (!!item) {
                        phaseObject.phaseLabel = item.label
                    }
                }
            }
            phaseObject.when = phaseObject.workingPhase;
            phaseObject.expertPhase = phaseObject.workingPhase;

            if (!!phaseObject.label) { phaseObject.actionDescription = phaseObject.label; }

            //let findings = scenario.assessmentFindings[cls['id']]
            //if (!!findings & findings !== "Unremarkable" & findings !== "Stable"){

            if (neededScenAssessments.includes(cls['id'])) {
                phaseObject.assessmentFB = "Thus you missed finding: " + scenario.assessmentFindings[cls['id']]
            }
            if (phaseObject.type === "required-action") {
                phaseObject.status = "missingRequiredAssessment"
            }
            //assign special status for items marked as "not-graded"

            if (!cls.graded) {
                phaseObject.status = "not-graded"
            }
            insertInPhaseRelativeToSuggestedOrder(phaseNames, phases, phaseObject, checklistSteps, i, confirmedEvents, checklistHierarchy, requiredPhaseNames, requiredSubphases, phaseRequiredAtEnd)
            //insertInPhaseInOrder(phaseNames, phases, phaseObject, i);
            indexCounter++;
        }
    });
    return [confirmedEvents, phaseNames, phases, indexCounter]
}



//rearrange the problem data structure for use during analysis

const setupProblems = (defs, sols, actions) => {
    let problems = [];
    if (actions.length !== 0) {
        for (let problemDef of defs) {
            let problem = {};
            let solutionIDs = problemDef.solutions;
            let probSols = sols.filter(sol => sol.problemID === problemDef.id)
            problem.probLabel = problemDef.label;
            problem.id = problemDef.id
            problem.lifeThreat = problemDef.lifeThreat
            problem.vitals = problemDef.vitals
            problem.allActions = []
            problem.allContras = []
            problem.allAlts = []
            let assessments = problemDef.assessments
            problem.assessments = assessments.map(obj => obj.assessmentID)
            problem.solutions = []
            for (let solID of solutionIDs) {
                let sol = probSols.filter(sol => sol.id === solID)[0]
                let solution = Object.assign({}, sol)
                solution.actions = []
                solution.otherActions = []
                solution.altActions = []
                let actEntries
                let actIDs = sol.actions
                actEntries = actions.filter(act => actIDs.includes(act.id))
                solution.actionsInSuggestedOrder = actEntries.filter(act =>
                    ["alternative", "required", "minimal", "optional"].includes(act.protocolRelationship))
                for (let entry of actEntries) {
                    let act = Object.assign({}, entry)
                    act.id = act.interventionID
                    let item = itemByID[act.id]
                    act.probLabel = problem.probLabel
                    act.altFound = undefined
                    if (!!item) {
                        act["id-label"] = item[0].label
                    }
                    else { act["id-label"] = act.id }
                    switch (act.protocolRelationship) {
                        case "not indicated":
                            solution.otherActions.push(act)
                            pushNew(act, problem.allContras)  //need to be able to annotate an action without deciding yet on which solution under
                            break
                        case "alternative":
                            solution.altActions.push(act)
                            pushNew(act, problem.allAlts)
                            break
                        case "required":
                        case "minimal":
                        case "optional":
                            solution.actions.push(act)
                            pushNew(act, problem.allActions)  //need to be able to annotate an action without deciding yet on which solution under
                            break
                        default:
                            break
                    }
                }
                problem.solutions.push(solution)
            }

            problems.push(problem);

        }
    }
    return (problems);
};



// create structure for tracking whether interventions are checked
const insertMissingIntvChecks = (events, statusTracking) => {
    let toUpdate
    for (const [key, entry] of Object.entries(statusTracking)) {
        if (Array.isArray(entry)) {
            for (let obj of entry) {
                let newObj = { "label": key, "foundCk": obj["foundCk"] }
                toUpdate = getEventsByIdTime(events, obj["intervention"], obj["timestamp"])
                for (let intv of toUpdate) {
                    if (!intv["intvStatus"].includes(newObj)) {
                        intv["intvStatus"].push(newObj)
                    }
                }
            }
        }
        else {
            let newObj = { "label": "intervention status", "foundCk": entry["foundCk"] }
            toUpdate = getEventsByIdTime(events, key, entry["timestamp"])
            toUpdate.forEach(intv => {
                if (!intv["intvStatus"].includes(newObj)) {
                    intv["intvStatus"].push(newObj)
                }
            })
        }
    }
    return events
}

function findBestSolMatch(prob, confirmedEvents) {
    prob.bestFittingSol = []
    let bestIndex = -1
    let finalIndex = -1
    let bestVal = -1
    let bestLen = -1
    let foundOneAltAction = false
    const solutions = prob.solutions
    solutions.forEach((sol, j) => {
        let solVal
        sol.found = []
        sol.notFound = []
        let variant
        sol.actions.forEach((action, f) => {

            variant = intvVariant2JSON(action.interventionVariant)  //convert object to string
            if (variant !== "{}"){
                let key = Object.keys(action.interventionVariant)[0]
                let val = action.interventionVariant[key]
                action.variantDetails = {}
                action.variantDetails[key] = {label: getPromptLabel(key) , givenVariant: getAnswerLabel(val)}
            }
            //not yet using variant info during analysis
            variant = "{}"
            action.intvVariant = variant
            if (confirmedEvents.includes(action.id + "+" + variant)) {
                (sol.found).push(action.id)
            }
            else {
                if (!action.protocolRelationship.includes("optional")) {
                    (sol.notFound).push(action)
                }
            }
        })
        let solLen = (sol.actions).length
        let solLenFound = (sol.found).length
        if (solLenFound === 0) {
            solVal = 0
        }
        else { solVal = solLenFound / solLen }
        if (solVal === 1 && solLenFound > bestLen) {  //prefer the longest solution match
            bestLen = solLenFound
            bestIndex = j
            finalIndex = j
        } //finalIndex represents a perfect match
        else {
            if (solVal >= bestVal && solLenFound > bestLen) {
                bestLen = solLenFound
                bestIndex = j
                bestVal = solVal
            }
        }

    })

    //address alternative actions.  First see if found one of the
    //alternative actions.  If not then push the first of the alternative
    //set onto the actions not found.
    if (finalIndex === -1) { finalIndex = bestIndex }
    let fSol = solutions[finalIndex]
    let altActsToRemove
    //need to adjust actions in suggested order to eliminate alts not being used
    fSol.ordering = [...fSol.actionsInSuggestedOrder]

    if (fSol.altActions.length !== 0) {
        let variant

        for (let action of fSol.altActions) {

            variant = intvVariant2JSON(action.interventionVariant) //convert object to string
            if (variant !== "{}"){
                let key = Object.keys(action.interventionVariant)[0]
                let val = action.interventionVariant[key]
                action.variantDetails = {}
                action.variantDetails[key] = {label: getPromptLabel(key) , givenVariant: getAnswerLabel(val)}
            }
            //not yet using variant info during analysis
            variant = "{}"
            action.intvVariant = variant

            if (confirmedEvents.includes(action.id + "+" + variant)) {
                foundOneAltAction = true
                break
            }
        }
        if (!foundOneAltAction) {
            let action = fSol.altActions[0]
            altActsToRemove = (fSol.altActions).filter(function (e) { return e.id != action.id }).map(e => e.id)
            fSol.notFound.push(action)
        }

        if (!!altActsToRemove) {
            fSol.ordering = (fSol.actionsInSuggestedOrder).filter(function (e) { return !altActsToRemove.includes(e.interventionID) })
            //console.log("ordering", fSol.ordering)
        }
    }


    return fSol
}

const insertMissingInterventions = (problems, confirmedEvents, indexCounter, phaseNames, phases) => {
    problems.forEach(prob => {
        //find the best fitting solution based on one with the max number of actions found
        let sol = findBestSolMatch(prob, confirmedEvents)
        prob.bestFittingSol = sol

        // now we just have to insert actions not found
        let actions = sol.notFound
        let variant
        actions.forEach((action, k) => {

            variant = intvVariant2JSON(action.interventionVariant)  //convert object to string
            if (variant !== "{}"){
                let key = Object.keys(action.interventionVariant)[0]
                let val = action.interventionVariant[key]
                action.variantDetails = {}
                action.variantDetails[key] = {label: getPromptLabel(key) , givenVariant: getAnswerLabel(val)}
            }
            //not yet using variant info during analysis
            variant = "{}"
            action.intvVariant = variant
            confirmedEvents.push(action.id)
            confirmedEvents.push(action.id + "+" + variant);
            let phaseObject = {
                "comment": "",
                "numericalID": indexCounter,
                "status": "",
                "intvStatus": [], //will be an array what patient status checks were and weren't done
                "required": true,
                "when": "",
                "suggestedPhase": "",
                "expertPhase": "",
                "probLabel": "",
                "minimalWhy": "",
                "assessmentsNeeded": "",
                "protocol": "",
                "protocolRelationship": "",
                "actionDescription": "",
                "type": "intervention",
                "timestamp": -1
            };

            //copy over the step fields that exist (type dependent)
            const ACTION_FIELDS = ["id", "phase", "why", "protocolRelationship"];
            ACTION_FIELDS.forEach(fldName => {
                if (!!action[fldName]) {
                    phaseObject[fldName] = action[fldName];
                }
            });

            phaseObject["intvVariant"] = action["interventionVariant"]

            if (phaseObject["protocolRelationship"] === "alternative") {
                phaseObject["protocolRelationship"] = "required"
            }

            const SOLUTION_FIELDS = ["minimalWhy", "protocols", "strictActionOrdering"];
            SOLUTION_FIELDS.forEach(fldName => {
                if (!!sol[fldName]) {
                    phaseObject[fldName] = sol[fldName];
                }
            });

            //copy over the step fields that exist (type dependent)
            const PROBLEM_FIELDS = ["probLabel"];
            PROBLEM_FIELDS.forEach(fldName => {
                if (!!prob[fldName]) {
                    phaseObject[fldName] = prob[fldName];
                }
            });

            //initialize some fields above that come from problem and action if they are defined
            if (!!prob.assessments) { phaseObject.assessmentsNeeded = prob.assessments }
            if (!!prob.protocols) { phaseObject.protocol = prob.protocols }
            if (!!action["id-label"]) { phaseObject.label = action["id-label"]; }
            if (!!action["id-label"]) { phaseObject.actionDescription = action["id-label"]; }
            let phaseVal
            if (!!action.subPhase) { phaseVal = action.subPhase }
            if (!!action.phase && !phaseVal) { phaseVal = action.phase }
            if (phaseVal) {
                phaseObject.when = phaseVal;
                phaseObject.expertPhase = phaseVal;
                phaseObject.suggestedPhase = phaseVal;
            }

            phaseObject.status = "missing" + capitalizeFirstLetter(phaseObject.protocolRelationship)
            //assume actions are in the suggested order to solve a problem
            if (!["optional", "not indicated", "unnecessary", "irrelevant", "redundant"].includes(phaseObject.protocolRelationship)) {
                let orderingIndex = (sol.ordering).findIndex(x => x.interventionID === phaseObject.id)
                insertInPhaseRelativeToSuggestedOrder(phaseNames, phases, phaseObject, sol.ordering, orderingIndex, confirmedEvents, checklistHierarchy, requiredPhaseNames, requiredSubphases, phaseRequiredAtEnd);
                indexCounter++;
            }
        })
    });
    return [indexCounter, phaseNames, phases]
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

//the main function for analyzing the observation log
function analyzeEvents(scen, log) {
    let events = log.events;

    // sts 1/23/22 moved the setting of the following into initGlobals()
    // setScenario(scenario)
    // setupSubphasePhaseLookup()
    // findSubphases();
    initGlobals(scen)

    //preprocess some of data from problems/solutions
    //and for now just flatten it some to set it up to
    //look more like the original problem actions in scenario
    // assumes there is just one solution per problem for now.
    let problemDefs = scenario.problems;
    let problemActions = scenario.actions;
    let problemSolutions = scenario.solutions;
    let problems
    //if (training){
        problems = setupProblems(problemDefs, problemSolutions, problemActions)//};


    //In the remainder, just dealing with the first solution for each problem
    //so if we ever have more than one solution for a problem this code needs to
    //be updated.  Would need to consider the additional solutions to decide which
    //solution is the best fit for the observer student


    let formattedActions = [];
    //if (training && problems.length !== 0) {
    if (problems.length !== 0) {
        let expectedScenInterventions = collectScenInterventions(problems)
        //add annotations that indicate what role each event plays in the problem solution
        let annotatedResults = annotateInputEvents(events, problems)
        //phaseNames and phases are two arrays synchronized be array indices
        //phases contains just the steps under the phase (thus could be a phase or subphase in observer interface)
        //phaseNames contains the label for each phase in phases.  Makes it a bit easier to search phaseNames to get the
        //indice for last instance of a phase label and access its objects
        let phases = annotatedResults[0];
        let phaseNames = annotatedResults[1];
        let confirmedEvents = annotatedResults[2]
        let intvsTracking = annotatedResults[3]


        //check the temporal constraints
        //first find the constraints relevant to this scenario
        //then determine which constraints if any were violated and setup the feedback

        filterConstraintsBySolutions(expectedScenInterventions)
        let kbUpdates = checkAgainstKB(phases, phaseNames, requiredPhaseNames, requiredSubphases, checklistHierarchy, itemByID, itemByLabel, constraintsViolated, phaseFB)
        phases = kbUpdates[0]
        phaseNames = kbUpdates[1]

        //add missing phase names to phaseNames
        //In the future, as do insertions for missing items may want to try to consider the temporal ordering constraints

        let updatedPhases = insertMissingSubphases(phases, phaseNames)
        phases = updatedPhases[0]
        phaseNames = updatedPhases[1]


        // check for missing assessment checklist steps and insert them
        let postAssessmentReview = checkForMissingAssessments(problems, events, confirmedEvents, phaseNames, phases)
        confirmedEvents = postAssessmentReview[0]
        phaseNames = postAssessmentReview[1]
        phases = postAssessmentReview[2]
        let indexCounter = postAssessmentReview[3]


        // check for and insert missing interventions

        // In the future may want to implement some dependency checking since interventions depend on appropriate assessments having
        // been done

        let postInterventionReview = insertMissingInterventions(problems, confirmedEvents, indexCounter, phaseNames, phases)
        indexCounter = postInterventionReview[0]
        phaseNames = postInterventionReview[1]
        phases = postInterventionReview[2]


        // end insert missing interventions


        // put together the phases into a single array ordered as directed by phases

        formattedActions = organizeLogDisplay(phaseNames, phases, requiredPhaseNames, problemStates, cautionStates, checklistHierarchy, subPhases, phaseFB, itemByID, itemByLabel);

        // Now that it is all rejoined into a single list, do some updating with additional
        // analysis results such as what intervention status checking was not done at some
        // time after the intervention was done

        formattedActions = insertMissingIntvChecks(formattedActions, intvsTracking)

        // check if any missing assessments can be inferred
        formattedActions = inferenceCheckingForAssessments(events, formattedActions, scen.name)



        let priorProb = "N/A";

        let finalActions = [];

        //insert intervention headers in condition 1 log if the switch is set to do so
        //currently insertInterventionHeader is false

        formattedActions.forEach((eventObj, j) => {
            let intvHeaderIndex = 1

            if (insertInterventionHeader && eventObj.type === "intervention" && eventObj.probLabel && !(priorProb === eventObj.probLabel)) {
                priorProb = eventObj.probLabel;
                let headerObject = {
                    "id": "interventionHeader",
                    "status": "good",
                    "phaseOrderStatus": "good",
                    "labelID": eventObj.probLabel,
                    "type": "header",
                    "numericalID": intvHeaderIndex++ / 3000,
                    "displayColor": "green",
                    //    "why": "",
                    "probLabel": eventObj.probLabel,
                    "protocol": ""
                };
                finalActions.push(headerObject);
            }
            finalActions.push(eventObj);
        });



        // start overall analysis to determine if all actions to solve a problem are present
        checkForMinimalCases(finalActions, formattedActions, problems)


        // end of overall analysis


        // Here only for development purposes
        console.log("Constraint Violation Results", constraintsViolated)

        // verify that scenario specified vitals have been checked twice
        //let vitalsCounts = doVitalsCounts(finalActions, scen.name)
        //doVitalsFeedback(finalActions, vitalsCounts, scen.name)
        //console.log("vitalsCounts: ", vitalsCounts)

        //remove analysis fields not needed by others before returning them
        let trimmedActions = trimActions(finalActions, analysisFields)

        const retVal = {
            "events": trimmedActions,
            // "FBfields": c2FB,
            "constraintsViolated": constraintsViolated,
            "requiredPhaseNames": requiredPhaseNames,
            "promptIDs": promptIDs,
            "decisionPromptIDs": scen.checkListCorrectness
            // "feedbackTemplates": assessmentEntries,
        }

        //for debugging summarizeAnalysis
        //Last bit is here for development purposes only since this call is made inside of condition 2
       let ds = scenarios[scen.name]
        if (ds && debugSummarize){
            console.log("Condition2 input produced by analysis", summarizeAnalysis (retVal, ds, itemByID))}

        console.log("Analysis completed for scenario: ", scen.name)
        return retVal
    }
    else {
        alert("This is a test scenario so an analysis cannot be done at this time but you can view the unanalyzed log.");
        return processRawLogForDisplay(events)
    }

}


export { analyzeEvents } //, requiredPhaseNames}